module.exports = __webpack_public_path__ + "static/media/fota_downloading.a6786bb8.png";